import { CheckBox } from 'devextreme-react/check-box';
import { DateBox } from 'devextreme-react/date-box';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { TextArea } from 'devextreme-react/text-area';
import React from 'react';
import TreeSelect from '../../../shared/TreeSelect';
import { AddNoteDialogViewProps } from '../hooks/useAddNoteDialogController';

const fieldStyle: React.CSSProperties = { marginBottom: 14 };
const labelStyle: React.CSSProperties = { marginBottom: 4, fontSize: 12, color: 'rgb(118, 118, 118)' };

const AddNoteDialogView: React.FC<AddNoteDialogViewProps> = ({
    visible,
    title,
    saving,
    treeNodes,
    treeValue,
    selectedLabel,
    targetLocked,
    comment,
    noteDate,
    showAudience,
    audienceRoles,
    onToggleRole,
    canSave,
    onTargetChange,
    onCommentChange,
    onDateChange,
    onSave,
    onCancel,
}) => {
    const saveButtonOptions = {
        text: 'Save',
        type: 'default',
        stylingMode: 'contained',
        disabled: !canSave,
        onClick: onSave,
    };

    const cancelButtonOptions = {
        text: 'Cancel',
        disabled: saving,
        onClick: onCancel,
    };

    return (
        <Popup
            visible={visible}
            onHiding={onCancel}
            title={title}
            width={520}
            height="auto"
            hideOnOutsideClick={false}
            showCloseButton={true}
            wrapperAttr={{ class: 'add-note-popup' }}
        >
            <ToolbarItem widget="dxButton" toolbar="bottom" location="after" options={saveButtonOptions} />
            <ToolbarItem widget="dxButton" toolbar="bottom" location="after" options={cancelButtonOptions} />

            <div style={fieldStyle}>
                <div style={labelStyle}>Task / Subtask</div>
                <TreeSelect
                    nodes={treeNodes}
                    value={treeValue}
                    selectedLabel={selectedLabel}
                    onChange={onTargetChange}
                    disabled={targetLocked}
                    placeholder="None — applies to the grant"
                    width="100%"
                    dropdownWidth={480}
                    dropdownHeight={340}
                    treeHeight={290}
                />
            </div>

            {showAudience && (
                <div style={fieldStyle}>
                    <div style={labelStyle}>Visible to</div>
                    {audienceRoles.map(role => (
                        <div key={role.value} style={{ marginBottom: 4 }}>
                            <CheckBox
                                value={role.selected}
                                text={role.label}
                                onValueChanged={() => onToggleRole(role.value)}
                            />
                        </div>
                    ))}
                </div>
            )}

            <div style={fieldStyle}>
                <div style={labelStyle}>Date</div>
                <DateBox
                    width="100%"
                    type="date"
                    value={noteDate ?? undefined}
                    onValueChanged={(e: any) => onDateChange(e.value ?? null)}
                />
            </div>

            <div style={fieldStyle}>
                <div style={labelStyle}>Note</div>
                <TextArea
                    width="100%"
                    value={comment}
                    height={120}
                    maxLength={2000}
                    placeholder="Enter your private note…"
                    valueChangeEvent="keyup input"
                    onValueChanged={(e: any) => onCommentChange(e.value ?? '')}
                />
            </div>
        </Popup>
    );
};

export default AddNoteDialogView;
